export default __webpack_public_path__ + "static/media/proj11.06cc8498.png";